import { fullDateLongFormat } from "@common/helpers/date";
import { Entity } from "@common/types/entity";
import { FinancialAccount } from "@common/types/financialAccount";
import { useFinancialAccountUpdateMutation } from "@api/financialAccount.api";
import { DatePicker } from "@design-system/DatePicker/DatePicker";

interface Props {
    financialAccount: FinancialAccount;
    entity: Entity;
}

export const AccountEndDate: React.FC<Props> = ({
    financialAccount,
    entity,
}) => {
    const updateAccount = useFinancialAccountUpdateMutation(financialAccount);
    const accountMinDate = financialAccount.bookkeepingStartDate;
    const minDate =
        accountMinDate && accountMinDate > entity.bookkeepingStartDate
            ? accountMinDate
            : entity.bookkeepingStartDate;

    return (
        <DatePicker
            mode="day"
            variant="panel-input"
            clearable
            showTriggerIcon={false}
            displayFormat={fullDateLongFormat}
            placeholder="Not set"
            value={financialAccount.bookkeepingEndDate ?? undefined}
            minDate={minDate}
            onValueChange={(date) =>
                updateAccount.mutate({ bookkeepingEndDate: date ?? null })
            }
            disabled={updateAccount.isPending}
        />
    );
};
